export default __webpack_public_path__ + "static/media/Lauren.3f616d13.jpg";